import { withInstallFunction } from '@sgui-plus/utils/with-install'

import Notify from './src/instance'

export const SgNotification = withInstallFunction(Notify, '$notify')
export default SgNotification

export * from './src/notification'
